import { startOfDay, startOfMonth, startOfWeek } from 'date-fns';
import { useCallback } from 'react';
import type { Mode } from '../../../../types';

export const useGetStartDate = () =>
  useCallback(({ date, mode }: { date: Date; mode: Mode }) => {
    switch (mode) {
      case 'day':
        return startOfDay(date);
      case 'month':
        return startOfWeek(startOfMonth(date));
      case 'week':
        return startOfWeek(date);
    }
  }, []);
